"use client";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { iconSize, radius } from "../../../core/design-system/index.js";
import { useWalletInfo } from "../../../core/utils/wallet.js";
import { Img } from "../../ui/components/Img.js";
import { Skeleton } from "../../ui/components/Skeleton.js";
import { ModalHeader } from "../../ui/components/basic.js";
import { ModalTitle } from "../../ui/components/modalElements.js";
/**
 * @internal
 */
export function EcosystemWalletHeader(props) {
    const walletInfo = useWalletInfo(props.wallet.id);
    return (_jsx(ModalHeader, { onBack: props.onBack, title: walletInfo.isLoading ? (_jsx(Skeleton, { height: "24px", width: "200px" })) : (_jsxs(_Fragment, { children: [!walletInfo.data?.image_id ? null : (_jsx(Img, { src: walletInfo.data?.image_id, style: {
                        borderRadius: radius.sm,
                    }, width: iconSize.md, height: iconSize.md, client: props.client })), _jsx(ModalTitle, { children: walletInfo.data?.name })] })), leftAligned: true }));
}
//# sourceMappingURL=EcosystemWalletHeader.js.map